import { sortBy } from "@utils/general";

import { IState } from "@redux/store.types";
import { generateDefaultSelectors, getApiDataState } from "@redux/utils";

import { $WishlistModuleName } from "./wishlist.types";

const { isLoading, error } = generateDefaultSelectors($WishlistModuleName);

const getWishlists = (state: IState) =>
    getApiDataState(state, $WishlistModuleName)?.data || [];

const getListWithId = (id?: string) => (state: IState) =>
    getWishlists(state).find(l => l.id === id);

const getLastUsedWishlist = (state: IState) => {
    return getWishlists(state).sort(sortBy("lastUpdated", false)).reverse().at(0);
}

const getFirstWishList = (state: IState) => {
    const wishlists = getWishlists(state);
    const wishlistsWithProducts = wishlists.filter(l => l.products.length > 0);

    if (wishlistsWithProducts.length === 1) {
        return wishlistsWithProducts.at(0);
    }

    if (wishlistsWithProducts.length > 1) {
        const sortedByProductsLength = wishlists.sort(
            (a, b) => b.products.length - a.products.length,
        );

        const firstProduct = sortedByProductsLength.at(0);
        const equalToFirstProductLength = sortedByProductsLength.filter(
            l => l.products.length === firstProduct?.products.length,
        );

        return equalToFirstProductLength.sort(sortBy("name", false)).at(0);
    }

    return wishlists.at(0);
};

const canRemoveList = (state: IState) => getWishlists(state).length > 1;

export {
    isLoading,
    error,
    getWishlists,
    getListWithId,
    canRemoveList,
    getFirstWishList,
    getLastUsedWishlist
};
